import { ErrorInBusesState } from '@buses/bus-results/store/reducers/ui/error-in-buses.reducer';
import { BusResultDesktop, BusResultsMobile, SearchResultsData } from '@app/entities/bus-results';
import { SearchPayload } from '@buses/bus-results/entities/request-search.payload';

export const busesResultsFeatureName = 'busesResultsModuleState';

export type UiBusesState = Readonly<{
  isLoadingBuses: boolean,
  isLoadingFilters: boolean,
  errorInBuses: ErrorInBusesState,
  itinerarySelected: string
}>;

export type BusesResultsModuleState = Readonly<{
  busesResultsDesktop: BusResultDesktop[],
  busesResultsMobile: BusResultsMobile[],
  searchResultsData: SearchResultsData,
  searchPayload: SearchPayload,
  ui: UiBusesState,
}>;
